import { getIsParent } from 'platform-components/src/components/user/selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import * as teamActions from 'common.components/classes/actions';
import * as teamSelectors from 'common.components/classes/selectors';
import { getCurrentTeamLevel } from 'common.components/user/selectors';
import { getDiagnostic, getIsDiagnosticLoading } from 'store/diagnostics/selectors';
import { courseSubscriptionsActions } from 'store/subscriptions/actions';

import { DiagnosticBanner } from './__diagnostic/overview-banner__diagnostic';
import { EmptyBanner } from './__empty/overview-banner__empty';
import { SubscriptionBanner } from './__subscription/overview-banner__subscription';
import { getCourseAvailableSubscription, getIsSubscriptionLoading } from './selectors';
import { BANNER_TYPES } from './typings';
import { useOverviewBannerType } from './useOverviewBannerType';

import './overview-banner.scss';

interface Props {
    courseId: number | null;
}

// eslint-disable-next-line complexity
export const OverviewBanner = (props: Props) => {
    const dispatch = useDispatch();
    const params = useParams<{ subject: string; classId: string }>();
    const { courseId } = props;
    const classId = Number(params.classId);
    const subject = params.subject;
    const shouldLoadTeamData = useSelector((store) => teamSelectors.getShouldLoadTeamData(store, { classId }));
    const isTeamLoaded = useSelector((store) => teamSelectors.getIsTeamLoaded(store, { classId }));
    const isParent = useSelector((store) => getIsParent(store));
    const grade = useSelector((store) => getCurrentTeamLevel(store, { classId }));
    const availableSubscription = useSelector((store) => getCourseAvailableSubscription(store, { courseId }));
    const isSubscriptionLoading = useSelector((store) => getIsSubscriptionLoading(store, { courseId }));

    const isDiagnosticLoading = useSelector((store) => getIsDiagnosticLoading(store, { subject }));
    const diagnostic = useSelector((store) => getDiagnostic(store, { subject }));

    const bannerType = useOverviewBannerType({ courseId });

    useEffect(() => {
        if (isParent && courseId && subject && grade) {
            dispatch(courseSubscriptionsActions.getAvailableSubscriptionsRequest({ courseId, subject, grade }));
        }
    }, [courseId, dispatch, grade, subject, isParent]);

    useEffect(() => {
        if (shouldLoadTeamData && classId) {
            dispatch(teamActions.getTeam(Number(classId)));
        }
    }, [classId, shouldLoadTeamData, dispatch]);

    if (!isTeamLoaded || isDiagnosticLoading || (isParent && isSubscriptionLoading)) {
        return null;
    }

    let BannerContent;
    switch (bannerType) {
        case BANNER_TYPES.CREATE_LESSON:
            BannerContent = <EmptyBanner courseId={courseId} />;
            break;
        case BANNER_TYPES.DIAGNOSTIC:
            // @ts-ignore проверка на существование диагностики в useOverviewBannerType
            BannerContent = <DiagnosticBanner courseId={courseId} diagnostic={diagnostic} />;
            break;
        case BANNER_TYPES.SUBSCRIPTION:
            BannerContent = <SubscriptionBanner courseId={courseId} subscription={availableSubscription} />;
            break;
    }

    return (
        <div className="overview-banner">
            <div className="overview-banner__content">{BannerContent}</div>
        </div>
    );
};
